"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVMTransferables = exports.EmptyCallData = exports.SendEtherGasLimit = exports.NativeAssetCallContract = exports.NativeAssetBalanceContract = exports.BaseShare = exports.EVM_HD_PATH = exports.JVM_HD_PATH = exports.EVM_ID = exports.JEVM_ID = exports.JVM_ID = exports.PLATFORMVM_ID = void 0;
const asset_1 = require("../asset");
exports.PLATFORMVM_ID = '11111111111111111111111111111111LpoYY';
exports.JVM_ID = 'otSmSxFRBqdRX7kestRW732n3WS2MrLAoWwHZxHnmMGMuLYX8';
exports.JEVM_ID = 'orkbbNQVf27TiBe6GqN5dm8d8Lo3rutEov8DUWZaKNUjckwSk';
exports.EVM_ID = 'mgj786NP7uDwBCcq6YwThhaN8FLyybkCa4zBWTQbNgmK6k9A6';
exports.JVM_HD_PATH = 9000;
exports.EVM_HD_PATH = 60;
exports.BaseShare = 1000000; // 100%
exports.NativeAssetBalanceContract = '0x0100000000000000000000000000000000000001';
exports.NativeAssetCallContract = '0x0100000000000000000000000000000000000002';
exports.SendEtherGasLimit = BigInt(21000);
exports.EmptyCallData = '0x';
exports.EVMTransferables = [asset_1.TokenType.ERC20, asset_1.TokenType.JRC20, asset_1.TokenType.Wrapped];
